import { Component, Prop, h } from '@stencil/core';

const COMPONENT_NAME = 'me-tag';

@Component({
  tag: 'me-tag',
  styleUrl: 'index.scss',
  shadow: false,
})
export class Tag {
  /**
   * If provided, the component renders as an <a> and becomes clickable.
   * If not provided, a <span> is used.
   */
  @Prop() href?: string;

  render() {
    const Tag = this.href ? 'a' : 'span';
    const classList = [COMPONENT_NAME].filter(Boolean).join(' ');

    return (
      <Tag class={classList} href={this.href} tabindex="0">
        <slot></slot>
      </Tag>
    );
  }
}
